var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-upload",
        {
          ref: "fileUpload",
          attrs: {
            accept: _vm.accept,
            action: _vm.action,
            "auto-upload": "",
            headers: _vm.headers,
            limit: _vm.limit,
            "before-upload": _vm.beforeUpload,
            "on-error": _vm.onError,
            "on-exceed": _vm.onExceed,
            "on-preview": _vm.onPreview,
            "on-remove": _vm.onRemove,
            "on-success": _vm.onSuccess,
            "file-list": _vm.fileList
          }
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                slot: "trigger",
                icon: "el-icon-search",
                size: "mini",
                type: "primary"
              },
              slot: "trigger"
            },
            [_vm._v("\n            File Select\n        ")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "el-upload",
              staticStyle: { "margin-left": "10px" },
              attrs: { slot: "tip" },
              slot: "tip"
            },
            [_vm._v("\n            File with size less than 5MB\n        ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-top": "20px" } },
        [
          _c("el-button", {
            attrs: {
              type: "primary",
              size: "mini",
              icon: "el-icon-s-promotion"
            },
            on: { click: _vm.sendDocument }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }